export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20arrangement%20of%20diverse%20lifestyle%20products%20including%20sneakers%20sunglasses%20leather%20goods%20and%20textiles%20floating%20in%20a%20dreamy%20organized%20composition%20on%20a%20soft%20gradient%20background%20from%20light%20warm%20beige%20to%20pale%20sage%20green%2C%20ethereal%20soft%20lighting%20with%20gentle%20shadows%2C%20editorial%20product%20photography%2C%20no%20text%20or%20logos%2C%20clean%20modern%20artistic%20aesthetic%2C%20air%20of%20sophistication&width=1800&height=1000&seq=hero-v2-main-bg&orientation=landscape"
          alt="AllChinaBuy Spreadsheet product styling"
          title="AllChinaBuy Spreadsheet – China Sourcing Products"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          AllChinaBuy Spreadsheet
          <br />
          <span className="text-white/90">The Most Complete China Sourcing Database for 2026</span>
        </h1>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Find verified suppliers, compare agents, and access real-time China sourcing data in one structured spreadsheet system.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-base rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-database-2-line text-lg"></i>
            AllChinaBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/20 backdrop-blur-sm text-white border border-white/30 font-semibold text-base rounded-full hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}